import { useTranslation } from 'react-i18next';
import { commonInfoItems } from '@/mocks/scheduleData';

const INFO_COUNT = 4;

export default function ApplicationDeadline() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('schedule.app.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('schedule.app.title')}
          </h2>
          {String(t('schedule.app.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('schedule.app.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="space-y-4">
          {Array.from({ length: INFO_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-4 bg-background-100/60 border border-background-200/60"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0 mt-0.5">
                <i className={[commonInfoItems[idx].icon, 'text-accent-600 text-sm'].join(' ')}></i>
              </div>
              <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed pt-1">
                {t(`schedule.info.${idx}`)}
              </p>
            </div>
          ))}
        </div>

        {String(t('schedule.app.footerNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-400 tracking-[0.04em] mt-6 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
